import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';

import { LOGIN, LOGOUT, AUTH_REFRESH, AUTH_REFETCH } from '../actions.types';
import { SET_AUTH, REMOVE_AUTH, SET_ERROR } from '../mutations.types';

export default {
  namespaced: true,
  state: {
    error: null,
    user: null,
    isAuthenticated: !!JwtService.getToken()
  },
  actions: {
    async [LOGIN]({ commit }, credentials) {
      try {
        const token = await ApiService.post('/v1/login', credentials);
        JwtService.saveToken(token.data);

        const user = await ApiService.get('/v1/users/me');
        commit(SET_AUTH, user.data.data);
      } catch (error) {
        commit(SET_ERROR, error.data);
      }
    },
    async [AUTH_REFRESH]({ commit }) {
      try {
        const token = await ApiService.post('/v1/refresh', {
          refresh_token: JwtService.getRefreshToken()
        });
        JwtService.saveToken(token.data);

        console.log('[SESSION.REFRESHED]', new Date().toLocaleString());
      } catch (error) {
        JwtService.destroyToken();
        commit(REMOVE_AUTH);
      }
    },
    async [AUTH_REFETCH]({ commit }) {
      try {
        const user = await ApiService.get('/v1/users/me');
        commit(SET_AUTH, user.data.data);
      } catch (error) {
        commit(REMOVE_AUTH);
      }
    },
    async [LOGOUT]({ commit }) {
      try {
        await ApiService.post('/v1/logout');
        commit(REMOVE_AUTH);
      } catch (error) {
        commit(REMOVE_AUTH);
      }
    }
  },
  mutations: {
    [SET_AUTH](state, user) {
      state.isAuthenticated = true;
      state.user = user;
      state.error = null;
    },
    [REMOVE_AUTH](state) {
      state.isAuthenticated = false;
      state.user = null;
      state.error = null;

      JwtService.destroyToken();
      window.location.href = '/login';
    },
    [SET_ERROR](state, error) {
      state.error = error;
    }
  }
};
